import { CLIENT_STATUSES } from '@admin/constants/general'
import { BADGE_VARIANTS } from 'components/Badge'
import { type StatusBadgeMapper } from './types'

export const CLIENT_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [CLIENT_STATUSES.ACTIVE]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [CLIENT_STATUSES.INACTIVE]: {
    variant: BADGE_VARIANTS.BROWN,
  },
  [CLIENT_STATUSES.SUSPENDED]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const
